import { TextMeasurer, useResize } from '@cronos-app/utils';
import { useCallback, useEffect, useRef, useState } from 'react';
const textMeasurer = new TextMeasurer();
export const useCollapsedText = ({ text, placeholder = '...', remain = 10, start = false, resize = true, }, wrapperRef) => {
    const cache = useRef({
        fontSize: 0,
        fontWeight: '',
        fontFamily: '',
        wrapperWidth: 0,
        text: '',
    });
    const [collapsedText, setCollapsedText] = useState(text);
    const getPart = useCallback((partLength, start) => start ? text.slice(0, partLength) : text.slice(text.length - partLength), [text]);
    const calcPart = useCallback(() => {
        const wrapper = wrapperRef?.current;
        if (!wrapper)
            return collapsedText;
        const { fontSize, fontWeight, fontFamily } = getComputedStyle(wrapper);
        const wrapperWidth = wrapper.offsetWidth;
        if (parseFloat(fontSize) === cache.current.fontSize &&
            fontFamily === cache.current.fontFamily &&
            fontWeight === cache.current.fontWeight &&
            wrapperWidth === cache.current.wrapperWidth &&
            text === cache.current.text) {
            return collapsedText;
        }
        cache.current = {
            fontFamily,
            fontWeight,
            fontSize: parseFloat(fontSize),
            wrapperWidth,
            text,
        };
        textMeasurer.config(parseFloat(fontSize), fontFamily, fontWeight);
        if (textMeasurer.calc(text) <= wrapperWidth)
            return text;
        let staticPartLength = Math.min(text.length - 2, remain);
        let dynamicPartLength = text.length - staticPartLength - 1;
        while (wrapperWidth && staticPartLength > 0) {
            const staticPart = getPart(staticPartLength, start);
            const dynamicPart = getPart(dynamicPartLength, !start);
            const tempWidth = textMeasurer.calc(staticPart + dynamicPart + placeholder);
            if (tempWidth <= wrapperWidth) {
                return start
                    ? staticPart + placeholder + dynamicPart
                    : dynamicPart + placeholder + staticPart;
            }
            if (dynamicPartLength === 1) {
                staticPartLength -= 1;
            }
            else {
                dynamicPartLength -= 1;
            }
        }
        return collapsedText;
    }, [text, placeholder, wrapperRef, remain, start, getPart, collapsedText]);
    const rerender = useCallback(() => {
        const _collapsedText = calcPart();
        if (_collapsedText !== collapsedText) {
            setCollapsedText(_collapsedText);
        }
    }, [calcPart, collapsedText, setCollapsedText]);
    useEffect(() => {
        rerender();
    }, [rerender]);
    useResize(() => {
        resize && rerender();
    });
    return {
        collapsedText,
    };
};
